module.exports = __webpack_public_path__ + "img/Thanks.a9f95761.png";